/* Publish by EComposer at 2026-10-28 04:29:53*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-79foymegc2m"]=  window.__ectimmers["ecom-79foymegc2m"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-79foymegc2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79foymegc2m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p100jflmso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p100jflmso', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-278tvlm5hquj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-278tvlm5hquj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tokyosamhsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tokyosamhsa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zx168bxv7tc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zx168bxv7tc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5e0yny4jao').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5e0yny4jao', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h1xia7b4syj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h1xia7b4syj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rupf6gddvoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rupf6gddvoi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lijuviz3zka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lijuviz3zka', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1b8czi06dini').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1b8czi06dini', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkya1rnb379').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkya1rnb379', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv8l0f3mtk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv8l0f3mtk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w407zluju4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w407zluju4e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcbwory8e3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcbwory8e3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nc5it76kun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nc5it76kun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyhkzb7y9ej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyhkzb7y9ej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kv854s5xhvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kv854s5xhvo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4ga4870y67s"]=  window.__ectimmers["ecom-4ga4870y67s"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-4ga4870y67s"]["9wi0nsgik"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-4ga4870y67s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ga4870y67s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g5c051qheaw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g5c051qheaw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rwc767a0kfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwc767a0kfc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5qh11vvzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5qh11vvzb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}